// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css/bundle";
import "./assets/css/icons.css";
import "./assets/css/app.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";


const app = ReactDOM.createRoot(document.getElementById("app"));
app.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
